import {DataFrame} from 'data-frames/DataFrameTypes';
import {RunQueryOutputLegacyData} from 'insights/warehouse/AnalyticsWarehouseTypes';

import isSystemColumn from '../isSystemColumn';
import convertDataFrameToDeprecatedDataFrame from './convertDataFrameToDeprecatedDataFrame';

/**
 * Convert a DataFrame to RunQueryOutputLegacyData
 *
 * As part of the conversion:
 *  - Float values will be deserialized from string to number.
 *  - Row-objects will be converted to row-arrays in the order of the columns in the `columns` array.
 *
 * @param dataFrame `DataFrame` to convert
 * @param includeSystemColumns When true, include system columns in the output, and don't include them otherwise.
 * Default is `true`.
 * @returns `RunQueryOutputLegacyData` converted from the `dataFrame`
 */
export default function convertDataFrameToRunQueryOutput(
  dataFrame: DataFrame,
  includeSystemColumns: boolean = true
): RunQueryOutputLegacyData {
  const legacyDataFrame = convertDataFrameToDeprecatedDataFrame(dataFrame);

  const columnsForConversion = dataFrame.columns.filter(
    (column) => includeSystemColumns || !isSystemColumn(column)
  );

  return {
    headers: columnsForConversion.map((column) => column.displayName),
    rows: legacyDataFrame.points.map((point) =>
      columnsForConversion.map((column) => point[column.systemName])
    ),
  };
}
